import client from './client';

export function logout() {
  // Clear all auth-related items from localStorage
  localStorage.removeItem('token');
  localStorage.removeItem('auth_cache'); // Clear auth cache
  // Add any other auth-related localStorage items that might exist
  
  // Reset the Apollo client store
  return client.resetStore().catch(error => {
    console.error('Error during logout/cache reset:', error);
    // Even if resetStore fails, ensure we complete the logout
    return Promise.resolve();
  });
}
